import type { SeasonalTheme, SoundEnvelope } from "./types"

/** Loudness of public/effects/bat.mp3 every 100 ms; regenerate with the ffmpeg recipe in docs/SEASONAL-THEMES.md. */
export const BAT_SOUND_ENVELOPE: SoundEnvelope = {
  bucketMs: 100,
  levels: [
    0, 0.08, 0.55, 0.95, 0.86, 0.63, 0.93, 0.69, 1, 0.86, 0.72, 0.55, 0.58, 0.54, 0.47, 0.48, 0.47, 0.39, 0.34, 0.24,
    0.24, 0.21, 0.18, 0.19, 0.14, 0.12, 0.11, 0.15, 0.09, 0.14, 0.12, 0.12, 0.08, 0.1, 0.1, 0.08, 0.11, 0.08, 0.11, 0.08,
    0.05, 0.05, 0.03, 0.03, 0.02, 0.02, 0.02, 0.01, 0.01,
  ],
}

/** Every seasonal theme the storefront knows; see docs/SEASONAL-THEMES.md to add one. */
export const SEASONAL_THEMES: readonly SeasonalTheme[] = [
  {
    id: "halloween",
    label: "Halloween",
    window: { kind: "month", month: 10 },
    regions: "global",
    priority: 10,
    effects: {
      orderConfirmed: {
        celebration: "bats",
        sound: "/effects/bat.mp3",
        soundEnvelope: BAT_SOUND_ENVELOPE,
        scene: "halloweenNight",
      },
    },
  },
]
